import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Card: React.FC<IconProps> = ({
  color = '#fff',
  size = 25,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size / 1.25} // Maintain aspect ratio 25/20
    viewBox="0 0 25 20"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M22.505 8v8c0 .442-.448.8-1 .8h-18c-.552 0-1-.358-1-.8V8h20zm0-1.6h-20V3.2c0-.442.448-.8 1-.8h18c.552 0 1 .358 1 .8v3.2zm-6.2 6.4a.8.8 0 100 1.6h2.4a.8.8 0 000-1.6h-2.4z"
      fill={color}
    />
  </svg>
)
